import react from "react";

const TenderCard =({tender}) =>{
    return (
        <>
         <div className="card mb-4 border-0 shadow-lg rounded-4">
  <div className="card-body">
    <div className="d-flex justify-content-between align-items-start mb-2">
      <h5 className="card-title mb-0">
        {tender.title}
      </h5>
      <span className="badge bg-secondary">
      
  {new Date(tender.closingDate).toLocaleDateString()}

      </span>
    </div>
   <a
  href={`http://localhost:5213${tender.fileUrl}`}
  className="btn btn-outline-primary btn-sm px-4 rounded-pill"
  target="_blank"
  rel="noopener noreferrer"
>
  📄 Download PDF
</a>
  </div>
</div>

        </>
    );
};

export default TenderCard;